export default __webpack_public_path__ + "static/media/CNo.59-5.8b21421c.jpg";